import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown, message } from 'antd';
import WorkerDropdownMenu from './WorkerDropdownMenu';
import WorkerNameBlock from './WorkerNameBlock';
import { SipPhoneContext } from '../../SipPhoneProvider';
import {
  setCallDirection,
  setIsControlPanelVisible,
  setSubscriber,
} from '../../../containers/Phone/store/actions';
import { callDirections } from '../../../containers/Phone/constants/callDirections';
import { formatPhoneNumber } from '../../../helpers/formatPhoneNumber';
import getWorkerPhone from '../../../requests/getWorkerPhone';
import { isControlPanelVisibleSelector } from '../../../containers/Phone/store/selectors';

const WorkerDropdown = ({
  workerKey,
  worker,
  allowCall,
  allowChange,
  renderContent,
  renderIcon
}) => {
  const { startCall } = useContext(SipPhoneContext);

  const isControlPanelVisible = useSelector(isControlPanelVisibleSelector);

  const dispatch = useDispatch();


  const handleChangeWorkerClick = (e, dispatch) => {
    e.domEvent.stopPropagation();

    if (typeof worker.change === 'function') {
      worker.change(dispatch)
    }
  };

  const handleCallWorkerClick = async (e) => {
    e.domEvent.stopPropagation();

    const workerPhone = worker.id ? await getWorkerPhone(worker?.id) : worker.phones?.[0];

    if (workerPhone) {
      const phone = formatPhoneNumber({phoneNumber: workerPhone})
      if (phone.length === 10) {
        if (!isControlPanelVisible) {
          dispatch(setIsControlPanelVisible(true));
        }

        dispatch(setCallDirection(callDirections.outgoing));

        const subscriber = {
          phone: formatPhoneNumber({
            phoneNumber: phone,
            format: '(xxx) xxx-xx-xx',
            placeholder: 'x',
          }),
        };

        if (worker.fullName) {
          subscriber.serviceCompany = worker.fullName;
        }

        dispatch(setSubscriber(subscriber));

        startCall(workerPhone);
      } else {
        message.error(
          'На этот номер не получится позвонить, потому что он не соответствует формату'
        );
      }
    } else {
      message.error(
        'На этот номер не получится позвонить, потому что он не соответствует формату'
      );
    }
  };

  return (
    <Dropdown
      overlay={
        <WorkerDropdownMenu
          worker={worker}
          onChangeWorkerClick={
            allowChange ? (e) => handleChangeWorkerClick(e, dispatch) : undefined
          }
          onCallClick={allowCall ? (e) => handleCallWorkerClick(e) : undefined}
        />
      }
    >
      {typeof renderContent === 'function' ? (
        renderContent({ withCursor: true })
      ) : (
        <WorkerNameBlock
          name={worker.fullName}
          speciality={worker.specialityName}
          workerKey={workerKey}
          withCursor
          renderIcon={renderIcon}
        />
      )}
    </Dropdown>
  );
};

export default WorkerDropdown;
